import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Ico from './iconBox';

// import HomeBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class Home extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
 


<br/>



<div className="container">
    <div className="row">
        <div className="col-12">
  
  




<h1>Guest Policies for YOVHO Hotels, Homes, and Stays</h1>

  <h2>General Booking Policy</h2>
  <p><strong>Destination-Specific Guidelines:</strong> Some cities or regions may have unique travel rules depending on local events, holidays, or government advisories. Guests are expected to comply with all applicable laws and travel guidelines at their destination.</p>
  <p><strong>Booking-Specific Terms:</strong> All booking-related policies, including check-in requirements, cancellation terms, and house rules, are specific to the property and will be communicated clearly during the reservation process or upon check-in.</p>

  <h3>Definition of Terms</h3>
  <p><strong>"YOVHO"</strong> refers to YOVHO and its affiliates, employees, and authorized representatives.</p>
  <p><strong>"Property" or "Hotel"</strong> refers to the YOVHO-partnered accommodation (hotel, guest house, apartment, hostel, or home) where the guest has made a valid booking through the YOVHO platform.</p>

  <h2>Need Help with Your Booking?</h2>
  <p>Whether you’re planning a new trip or need help with an existing reservation, YOVHO’s Booking Experts are available 24/7 to assist you—day or night.</p>
  <p><strong>Call or WhatsApp:</strong> +92 316 6611136</p>
  <p><strong>Email:</strong> customer.care@yovho.com</p>

  <h2>Check-in Policy – YOVHO</h2>
  <ul>
    <li>The primary guest must be at least 18 years of age to check into a YOVHO-partnered property.</li>
    <li>Standard check-in time is 12:00 noon.</li>
    <li>All guests aged 18+ must present valid original government-issued photo ID: CNIC or Passport.</li>
    <li>Photocopies or digital IDs are not accepted.</li>
    <li>Unmarried couples are not permitted. Proof of marriage may be requested at check-in.</li>
  </ul>

  <h3>If You Face a Check-in Issue</h3>
  <p>Contact us immediately:</p>
  <ul>
    <li>📞 +92 316 6611136</li>
    <li>📧 customer.care@yovho.com</li>
  </ul>
  <p>Options may include same-property accommodation, relocation to another YOVHO property, or a full refund. YOVHO’s liability is limited to the original booking value.</p>

  <h2>Force Majeure</h2>
  <p>In cases of natural disasters, government restrictions, or other force majeure events, YOVHO may not be able to provide accommodation or refunds.</p>

  <h2>Early Check-in and Late Check-out Policy</h2>
  <p>Subject to availability and applicable charges.</p>







<h2>Check-in Time</h2>
  <table style={{
     width: "100%",
      borderCollapse: "collapse",
      margin: "20px 0",
      backgroundColor: "#fff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      borderRadius: "6px",
      overflow: "hidden"
  }}>
    <thead>
      <tr>
        <th>Check-in Time</th>
        <th>Applicable Charges</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Before 6:00 AM</td>
        <td>100% of room rate (previous day’s rate)</td>
      </tr>
      <tr>
        <td>6:00 AM – 10:00 AM</td>
        <td>0%–30% of room rate (based on hotel policy)</td>
      </tr>
      <tr>
        <td>10:00 AM – 12:00 PM</td>
        <td>Complimentary</td>
      </tr>
    </tbody>
  </table>

<br />

  <h2>Check-out Time</h2>
  <table style={{
     width: "100%",
      borderCollapse: "collapse",
      margin: "20px 0",
      backgroundColor: "#fff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      borderRadius: "6px",
      overflow: "hidden"
  }}>
    <thead>
      <tr>
        <th>Check-out Time</th>
        <th>Applicable Charges</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>11:00 AM – 1:00 PM</td>
        <td>Complimentary</td>
      </tr>
      <tr>
        <td>1:00 PM – 5:00 PM</td>
        <td>Up to 30% of room rate</td>
      </tr>
      <tr>
        <td>After 5:00 PM</td>
        <td>100% of room rate</td>
      </tr>
    </tbody>
  </table>






  {/* <table>
    <thead>
      <tr><th>Check-in Time</th><th>Applicable Charges</th></tr>
    </thead>
    <tbody>
      <tr><td>Before 6:00 AM</td><td>100% of room rate (previous day’s rate)</td></tr>
      <tr><td>6:00 AM – 10:00 AM</td><td>0%–30% of room rate (based on hotel policy)</td></tr>
      <tr><td>10:00 AM – 12:00 PM</td><td>Complimentary</td></tr>
    </tbody>
  </table>

  <table>
    <thead>
      <tr><th>Check-out Time</th><th>Applicable Charges</th></tr>
    </thead>
    <tbody>
      <tr><td>11:00 AM – 1:00 PM</td><td>Complimentary</td></tr>
      <tr><td>1:00 PM – 5:00 PM</td><td>Up to 30% of room rate</td></tr>
      <tr><td>After 5:00 PM</td><td>100% of room rate</td></tr>
    </tbody>
  </table> */}


<br />

  <h3>Booking Extension Policy</h3>
  <p>Extensions depend on availability and are charged at current rates, not original booking rates.</p>

  <h2>Cancellation Policy – YOVHO</h2>
  <p>You may cancel via the website, app, or customer support.</p>
  <ul>
    <li>Refunds, if applicable, are processed within 7–14 business days.</li>
    <li>Refunds are subject to YOVHO Wallet balance adjustment.</li>
    <li>No refund if check-in is denied due to lack of ID, unaccompanied minors, or other policy violations.</li>
  </ul>



  

















 <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <strong>Long-Stay Bookings</strong>
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    For bookings <strong>exceeding 7 nights</strong>, guests are required to{" "}
    <strong>settle any outstanding payments on a weekly basis</strong>.
    Continued accommodation will only be confirmed once dues are cleared in
    full.
  </p>
  <hr
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  />
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <strong>Triple Occupancy Policy</strong>
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Select YOVHO partner properties allow <strong>triple occupancy</strong>.
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        A <strong>third guest</strong> may be accommodated with an{" "}
        <strong>extra mattress</strong>, subject to an{" "}
        <strong>additional fee</strong>.
      </p>
    </li>
    <li>
      <p>
        <strong>Extra beds are generally not provided</strong> unless explicitly
        mentioned.
      </p>
    </li>
  </ul>
  <hr
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  />
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <strong>Visitor Policy</strong>
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Visitor policies may vary by property. We encourage all guests to check
    directly with the hotel at check-in. However, for safety and privacy, YOVHO
    recommends the following standard visitor guidelines:
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        <strong>Visitors may be allowed</strong> in guest rooms{" "}
        <strong>during the day only</strong>, except in emergencies.
      </p>
    </li>
    <li>
      <p>
        <strong>Overnight stays for visitors are not permitted</strong>.
      </p>
    </li>
    <li>
      <p>
        <strong>
          All visitors must present valid government-issued photo ID
        </strong>{" "}
        before entering guest floors.
      </p>
    </li>
  </ul>
  <hr
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  />
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <strong>Child Policy</strong>
  </h3>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        <strong>One child under the age of 5</strong> may stay{" "}
        <strong>free of charge</strong>, provided{" "}
        <strong>no extra mattress is used</strong>.
      </p>
    </li>
    <li>
      <p>
        <strong>Breakfast charges may apply</strong> for children, depending on
        the hotel.
      </p>
    </li>
  </ul>
  <hr
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  />
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <strong>Pet Policy</strong>
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <em>
      (Applicable only at select YOVHO Partner Properties that permit pets)
    </em>
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        Pets must be <strong>vaccinated</strong>, and guests must present the{" "}
        <strong>vaccination certificate</strong> at check-in.
      </p>
    </li>
    <li>
      <p>
        Pets should remain <strong>on a leash</strong> while on the property.
      </p>
    </li>
    <li>
      <p>
        Only <strong>dogs and cats</strong> are allowed, with a maximum of{" "}
        <strong>1 pet per room</strong>.
      </p>
    </li>
    <li>
      <p>
        <strong>Pet food is not provided</strong> by the hotel.
      </p>
    </li>
    <li>
      <p>
        <strong>Pets are not allowed</strong> in the following areas:{" "}
        <strong>beds, swimming pools, restaurants</strong>.
      </p>
    </li>
    <li>
      <p>
        Pet owners must <strong>avoid causing inconvenience</strong> to other
        guests.
      </p>
    </li>
    <li>
      <p>
        Additional <strong>cleaning charges or penalties</strong> may apply if
        pets cause damage.
      </p>
    </li>
    <li>
      <p>
        Guests are advised to bring <strong>poop bags and muzzles</strong>.
      </p>
    </li>
  </ul>
  <hr
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  />
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <strong>YOVHO Service On-Time Policy</strong>
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Select YOVHO partner hotels offer{" "}
    <strong>guaranteed issue resolution within 1 hour</strong>.
  </p>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    If you face any serious issue during your stay:
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        YOVHO will either <strong>resolve the issue within 60 minutes</strong>,
        or
      </p>
    </li>
    <li>
      <p>
        <strong>Offer an alternative room</strong> in the same hotel, or
      </p>
    </li>
    <li>
      <p>
        <strong>Shift you to another available YOVHO property</strong>.
      </p>
    </li>
  </ul>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <img
      alt="📞"
      draggable="false"
      src="https://fonts.gstatic.com/s/e/notoemoji/16.0/1f4de/32.png"
    />{" "}
    To register an issue, please contact:
    <br />
    <strong>Customer Care</strong>: +923166611136
    <br />
    Email:{" "}
    <a rel="noopener" style={{ color: "rgb(34, 34, 34)" }}>
      customer.care@yovho.com
    </a>
  </p>

  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
   
    <strong>
      <br />
      Code of Conduct
    </strong>
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    YOVHO maintains strict compliance with local laws and respectful guest
    conduct. The following will lead to cancellation of stay or eviction from
    the hotel:
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        Refusing or failing to <strong>pay for your stay</strong>.
      </p>
    </li>
    <li>
      <p>
        Engaging in <strong>disorderly conduct</strong> or disturbing other
        guests.
      </p>
    </li>
    <li>
      <p>
        <strong>Damaging or threatening hotel property</strong> or personnel.
      </p>
    </li>
    <li>
      <p>
        Any <strong>illegal or inappropriate activities</strong> during your
        stay.
      </p>
    </li>
  </ul>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Guests are expected to maintain <strong>cleanliness and hygiene</strong> in
    their rooms. You may be held liable for damage to hotel assets (excluding
    normal wear and tear).
  </p>
  <hr
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  />
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <br />
    <strong>Smoking, Drugs &amp; Alcohol Policy</strong>
  </h3>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        <strong>Smoking is not permitted</strong> in YOVHO Townhouse properties.
        Some hotels may also enforce <strong>non-smoking</strong> rules in guest
        rooms—please check with the front desk.
      </p>
    </li>
    <li>
      <p>
        <strong>Drug use or possession</strong> is strictly prohibited and will
        be reported to law enforcement authorities.
      </p>
    </li>
    <li>
      <p>
        Consumption of&nbsp;<strong>alcohol is strictly not allowed</strong> in
        rooms and in public areas such as lobbies, corridors, or parking lots
        <br />
        <br />
   
      
      </p>
      <h2>Safety &amp; Security&nbsp;</h2>
      <p>
        At <strong>YOVHO</strong>, the safety and peace of mind of our guests is
        a top priority. Please read and follow these important guidelines during
        your stay:
      </p>
      <p>
        <br />
      </p>
      <ol>
        <li>
          <p>
            <strong>Emergency &amp; Fire Safety Procedures</strong>
            <br />
            For your protection, we request all guests to{" "}
            <strong>
              adhere strictly to fire safety instructions and emergency
              protocols
            </strong>{" "}
            as communicated by the hotel staff. Emergency exits and evacuation
            plans are clearly marked in all partner properties.
          </p>
        </li>
        <li>
          <p>
            <strong>Valuables and Personal Belongings</strong>
            <br />
            YOVHO and its partner hotels{" "}
            <strong>
              do not accept responsibility for the loss, damage, or theft
            </strong>{" "}
            of any personal belongings, valuables, or luggage during your stay.
            Please ensure all doors and windows are securely locked when leaving
            the room.
          </p>
        </li>
      </ol>
    </li>
  </ul>
  <p>
    <br
      style={{
        textAlign: "start",
        color: "rgb(34, 34, 34)",
        backgroundColor: "rgb(255, 255, 255)",
        fontSize: "small",
        fontFamily: "Arial, Helvetica, sans-serif"
      }}
    />
  </p>
  <h2
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    &nbsp;Contact Policies&nbsp;
  </h2>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    At <strong>YOVHO</strong>, we aim to deliver a seamless and secure guest
    experience. Please review our contact policy below:
  </p>
  <ol
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        <strong>Pre-Arrival Communication</strong>
        <br />
        Our team may contact you prior to your check-in date via phone call,
        SMS, or messaging platforms to{" "}
        <strong>confirm your arrival details and expected check-in time</strong>
        .
      </p>
    </li>
    <li>
      <p>
        <strong>Non-Response to Communication</strong>
        <br />
        In case we are unable to reach you after{" "}
        <strong>multiple contact attempts</strong>, or if we receive{" "}
        <strong>no confirmation of your arrival</strong>, your reservation may
        be <strong>temporarily placed on hold or cancelled</strong> for security
        and operational reasons.
      </p>
      <ul>
        <li>
          <p>
            Your booking may be reinstated upon <strong>reconfirmation</strong>{" "}
            or <strong>successful payment</strong> via our secure payment
            gateways—<strong>subject to availability at that time</strong>.
          </p>
        </li>
      </ul>
    </li>
    <li>
      <p>
        <strong>Feedback &amp; Service Improvement</strong>
        <br />
        Post-stay, we may contact you to request{" "}
        <strong>feedback about your experience</strong> with YOVHO. Your input
        helps us enhance our services and deliver better stays.
      </p>
    </li>
    <li>
      <p>
        <strong>Promotional Outreach</strong>
        <br />
        Occasionally, you may receive{" "}
        <strong>messages or calls from YOVHO</strong> regarding{" "}
        <strong>exclusive offers, discounts, or updates</strong>. You may opt
        out of promotional communication anytime by following the opt-out
        instructions provided.
      </p>
    </li>
  </ol>
  <p>
   
  </p>
  <p>
    <br
      style={{
        textAlign: "start",
        color: "rgb(34, 34, 34)",
        backgroundColor: "rgb(255, 255, 255)",
        fontSize: "small",
        fontFamily: "Arial, Helvetica, sans-serif"
      }}
    />
  </p>
 
  <h2
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Beware of Fraud – Stay Secure with YOVHO
  </h2>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    At <strong>YOVHO</strong>, your <strong>security and trust</strong> are our
    top priorities. Please take note of the following important advisory:
  </p>
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    &nbsp;Authorized Payment Channels Only
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    YOVHO <strong>does not authorize</strong> any employee, consultant, vendor,
    or partner to{" "}
    <strong>
      collect payments via cash, personal accounts, or unofficial links
    </strong>
    .
  </p>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    All payments must be made <strong>only through:</strong>
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        <strong>YOVHO’s official website or app</strong>
      </p>
    </li>
    <li>
      <p>
        <strong>
          Secure payment links provided through verified YOVHO channels
        </strong>
      </p>
    </li>
    <li>
      <p>
        <strong>
          Affiliated and trusted OTA (Online Travel Agency) gateways
          <br />
          <br />
        </strong>
      </p>
    </li>
  </ul>
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    &nbsp;Report Suspicious Activity
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Any request for payment via <strong>unauthorized methods</strong> (such as
    personal bank accounts, third-party apps, or random QR codes) should be
    treated as a <strong>fraudulent act</strong>. YOVHO{" "}
    <strong>is not liable</strong> for any loss or damages resulting from such
    unauthorized transactions.
  </p>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    If you suspect fraud or encounter a suspicious request, please:
  </p>
  <ul
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <li>
      <p>
        <strong>Do not proceed with payment</strong>
      </p>
    </li>
    <li>
      <p>
        <strong>Report the incident immediately to</strong>: &nbsp;
        <a
          href="mailto:fraud.alert@yovho.com"
          target="_blank"
          style={{ color: "rgb(17, 85, 204)" }}
        >
          fraud.alert@yovho.com
        </a>{" "}
        or call us at <code>+923166611136</code>
      </p>
    </li>
  </ul>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Your awareness helps protect you and others from online scams. Always verify
    before you pay!
    <br />
    <br />
 
  </p>
  <h2
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    Contact YOVHO Support
  </h2>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    At <strong>YOVHO</strong>, we are committed to ensuring your stay is smooth,
    secure, and satisfying. While we work closely with our verified hotel,
    guesthouse, and apartment partners to deliver a quality experience, we
    understand that you may occasionally need additional support.
  </p>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    If any issue arises during your stay that is{" "}
    <strong>not resolved by the hotel staff</strong>, please feel free to
    escalate it to <strong>YOVHO</strong> for prompt assistance.
  </p>
  <blockquote
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <p>
      <strong>Please note:</strong> We are unable to address complaints
      made&nbsp;<strong>after checkout</strong>, so kindly reach out to us
      during your stay.
      <br />
      <br />
    </p>
  </blockquote>
  <h3
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    &nbsp;Need Help During Your Stay?
  </h3>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    You can contact our 24/7 support team for any help or assistance at
    <br />
    <strong>Email:</strong>{" "}
    <a rel="noopener" style={{ color: "rgb(34, 34, 34)" }}>
      support@yovho.com &nbsp; &nbsp;
    </a>
    <strong>Phone / WhatsApp:</strong> +92 316 6611136
  </p>
  <h2
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    <br />
    &nbsp;Grievance Redressal
  </h2>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    For formal complaints or unresolved issues, you may contact our{" "}
    <strong>Grievance Officer</strong>:
  </p>
  <p
    style={{
      textAlign: "start",
      color: "rgb(34, 34, 34)",
      backgroundColor: "rgb(255, 255, 255)",
      fontSize: "small",
      fontFamily: "Arial, Helvetica, sans-serif"
    }}
  >
    &nbsp;<strong>+971 555 562053</strong> | <strong>+92 316 6611136</strong>
    <br />
    <strong>
      <a rel="noopener" style={{ color: "rgb(34, 34, 34)" }}>
        &nbsp;customer.care@yovho.com
      </a>
    </strong>
  </p>









        </div>
    </div>
</div>

















        
          </div>
        )
    }
}

export default Home;